import styled from "styled-components";

export const StyledUploadTimeSheet = styled.div`
display: inline;

.file_hide {
    visibility: hidden;
    display: none;
}

.button_upload {
    background-color: #EE4B21;
    color: #FFF;
    font-size: 12px;
    border: none;
    border-radius: 5px;
    padding: 0.5rem 1rem;
    cursor: pointer;
    font-weight: 600;
    border: solid 1px #EE4B21;
    border-radius: 0.25rem;
    font-size: 0.8rem;
    &:hover {
        background-color: #c83e1b;
        border: solid 1px #c83e1b;
    }
    &:disabled {
        cursor: not-allowed;
    }
}
`;